<template lang="pug">
  v-content
    v-container(fluid grid-list-md)
      v-layout(row wrap)
        v-flex(xs12)
          v-card
            v-card-title
              v-layout(row wrap)
                v-flex(xs12)
                  v-btn(@click="openEditDialog" color="primary") 新規追加
                  v-btn(@click="exportConfirm" color="success" :loading="loading.export") 出力
                  v-btn(color="info" to="/tms/management/fixed-payment-rate/import") インポート

            v-card-text
              v-layout(row wrap)
                v-flex(xs12)
                  v-card
                    v-card-text
                      FixedPaymentRateFilterConditions(@onChangeSearchConditions="onChangeSearchConditions" ref="FixedPaymentRateFilterConditions")

            v-card-text
              section.table-scroll-x.sticky-container(ref="container")
                FixedPaymentRateTable.content-table(ref="FixedPaymentRateTable" :prop-header="tableHeaderAddVehicleTypeList" :prop-data="dataList" @open-detail="openDetail" detail-url="fixedPaymentRate/fetchFixedPaymentRate" :getListActionName="getListActionName" displaySlotBody)
                  template(v-slot:body="{body}")
                    td {{ body.client.clientDisplayName }}
                    td {{ body.clientBranch.branchName }}
                    td {{ body.primaryDeliveryCompany.nameAndCd }}
                    td {{ body.loadingBase.nameAndCd }}
                    td {{ body.unloadingBase.nameAndCd }}
                    td {{ body.applicableStartDate }}
                    td
                      v-tooltip(top)
                        template(v-slot:activator="{ on }")
                          p(v-on="on").remark.whitespace-pre {{ body.remark }}
                        span.whitespace-pre {{ body.remark }}
                    template(v-for="detail in body.fixedPaymentRateDetails")
                      td.text-xs-right
                        DigitSeparatorsLabel(:value="detail.price")

    ExportConfirmDialog(ref="ExportConfirmDialog" @yes="exportData('fixedPaymentRate/export')")
    FixedPaymentRateEditDialog(ref="FixedPaymentRateEditDialog" :postUrl="$config.urls.postEditFixedPaymentRate" :deleteUrl="$config.urls.deleteFixedPaymentRate" @updated="itemUpdated" @deleted="itemUpdated")
</template>

<script>
import FixedPaymentRateEditDialog from "@/components/management/fixed-payment-rate/FixedPaymentRateEdit";
import FixedPaymentRateTable from "@/components/common/PagingListTable";
import FixedPaymentRateFilterConditions from "@/components/management/fixed-payment-rate/FixedPaymentRateFilterConditions";
import DigitSeparatorsLabel from "@/components/common/DigitSeparatorsLabel";

import ExportHandler from "@/mixin/ExportHandler";
import ExportConfirmDialog from "@/components/common/dialog/ExportConfirmDialog";
import { LimitNumber } from "@/assets/js/constants";

export default {
  components: {
    FixedPaymentRateEditDialog,
    FixedPaymentRateTable,
    FixedPaymentRateFilterConditions,
    DigitSeparatorsLabel,
    ExportConfirmDialog
  },
  mixins: [ExportHandler],
  data() {
    return {
      vehicleTypeList: [],
      oldScrollTop: null
    };
  },
  computed: {
    dataList: {
      get() {
        return this.$store.state.fixedPaymentRate.fixedPaymentRateList;
      }
    },
    getListActionName: {
      get() {
        return "fixedPaymentRate/fetchAll";
      }
    },
    tableHeader: {
      get() {
        return [
          { text: "荷主", value: "client.clientDisplayName", centerAlign: "" },
          { text: "荷主枝番", value: "clientBranch.branchName", centerAlign: "" },
          { text: "1次委託先会社", value: "primaryDeliveryCompany.companyName", centerAlign: "" },
          { text: "積地", value: "loadingBase.displayBaseName", centerAlign: "" },
          { text: "卸地", value: "unloadingBase.displayBaseName", centerAlign: "" },
          { text: "適用開始日", value: "applicableStartDate", centerAlign: true },
          { text: "備考", value: "remark", centerAlign: "" }
        ];
      }
    },
    tableHeaderAddVehicleTypeList: {
      get() {
        let tableHeaderAddVehicleTypeList = this.tableHeader.slice();
        this.vehicleTypeList.forEach(vehicleType => {
          tableHeaderAddVehicleTypeList.push({ text: vehicleType.vehicleTypeName });
        });
        return tableHeaderAddVehicleTypeList;
      }
    }
  },
  mounted() {
    this.loadListData();
    this.$refs.container.removeEventListener("scroll", this.handleScroll);
    this.$refs.container.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    /**
     * 新規作成ダイアログの表示
     */
    openEditDialog() {
      this.$refs.FixedPaymentRateEditDialog.openDialog();
    },
    /**
     * 詳細ダイアログの表示
     * @param item
     */
    openDetail(item) {
      this.$refs.FixedPaymentRateEditDialog.openDialog(item);
    },
    /**
     * データの読み込み
     * @param params
     */
    loadListData() {
      this.$refs.FixedPaymentRateTable.loadData();
      // テーブルヘッダー用に車格取得
      this.$store.dispatch("tariff/fetchTariffUseVehicleTypeList").then(data => {
        this.vehicleTypeList = data;
      });
    },
    /**
     * レコード追加・更新・削除時に検索同様ページ番号0にして再取得
     */
    itemUpdated(response, data) {
      this.$refs.FixedPaymentRateTable.resetPageCount();
      this.loadListData();
    },
    /**
     * 検索条件欄に入力されたら発火
     * @param searchCond
     */
    onChangeSearchConditions(searchCond) {
      this.searchCond = searchCond;
      this.$refs.container.scrollTop = 0;
      this.$refs.FixedPaymentRateTable.setSearchConditions(searchCond);
      this.$refs.FixedPaymentRateTable.resetPageCount();
      this.loadListData();
    },
    /**
     * 出力ダイアログの表示
     */
    exportConfirm() {
      this.$refs.ExportConfirmDialog.openDialog();
    },
    handleScroll() {
      if (this.$refs.container !== undefined) {
        const clientHeight = this.$refs.container.clientHeight;
        const scrollTop = this.$refs.container.scrollTop;
        const scrollHeight = this.$refs.container.scrollHeight;
        if (this.oldScrollTop === scrollTop) return;
        // 横スクロール用にスクロールトップ退避
        this.oldScrollTop = scrollTop;

        if (
          scrollHeight - clientHeight - scrollTop < LimitNumber.ScrollNumber &&
          !this.$refs.FixedPaymentRateTable.getProgress()
        ) {
          this.$refs.FixedPaymentRateTable.addPageCount();
          this.$refs.FixedPaymentRateTable.loadData();
        }
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
>>> .sticky_table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  table-layout: auto;
}

>>> .sticky_table thead th {
  background-color: #fff;
  position: -webkit-sticky;
  position: sticky;
	top: 0;
  z-index: 1;
}
</style>
